import { action } from 'mobx'
import { WorkSchedulePersonalRequest } from '../requests/WorkSchedulePersonalRequest'

class WorkScheduleStore {
  @action createOrUpdateWorkSchedulePersonal = submitData => {
    return new Promise((resolve, reject) => {
      WorkSchedulePersonalRequest.createOrUpdateWorkSchedulePersonal(submitData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getWorkSchedulePersonalList = (startDate, endDate) => {
    return new Promise((resolve, reject) => {
      WorkSchedulePersonalRequest.getWorkSchedulePersonalList(
        startDate,
        endDate
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getDetailWorkSchedulePersonal = (workDate, executedBy) => {
    return new Promise((resolve, reject) => {
      WorkSchedulePersonalRequest.getDetailWorkSchedulePersonal(
        workDate,
        executedBy
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getWorkSchedulePersonalListByDepartment = (
    startDate,
    endDate,
    department
  ) => {
    return new Promise((resolve, reject) => {
      WorkSchedulePersonalRequest.getWorkSchedulePersonalListByDepartment(
        startDate,
        endDate,
        department
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getHistory = (
    username, startDate, endDate
  ) => {
    return new Promise((resolve, reject) => {
      WorkSchedulePersonalRequest.getHistory(
        username, startDate, endDate
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default new WorkScheduleStore()
